import { createUseStyles } from 'react-jss'
import Arrow from '../../assets/icons/icon_right_arrow.svg'

const useStyles = createUseStyles((theme) => {
  const text = {
    fontSize: '1.4rem',
    lineHeight: 1.25,
    colot: theme.colors.text,
    margin: 0,
  }
  return {
    container: {
      display: 'flex',
      flex: 1,
      gap: 'var(--ui-spacer-m)',
      padding: 'var(--ui-spacer-m)',
      backgroundColor: 'var(--ui-profile-card-background-color)',
      borderRadius: 'var(--ui-radius-l)',
    },
    avatarContainer: {
      flexBasis: '7.2rem',
    },
    avatar: {
      width: '7.2rem',
      cursor: 'pointer',
    },
    avatarUploading: {
      opacity: 0.5,
      cursor: 'default',
    },
    info: {
      flex: '1 1 auto',
    },
    avatarLabel: {
      position: 'relative',
      overflow: 'hidden',
    },
    avatarInput: {
      visibility: 'hidden',
      position: 'absolute',
      top: '-99999rem',
      left: '-99999rem',
    },
    name: {
      extend: text,
      fontSize: '1.6rem',
    },
    rank: ({ rankHexValue, rankBgHexValue }) => ({
      lineHeight: '2rem',
      marginRight: '0.4rem',
      padding: '0.2rem .5rem',
      background: rankBgHexValue || theme.colors.disabled,
      color: rankHexValue || theme.colors.background,
      fontSize: '1rem',
      fontWeight: 300,
      borderRadius: '.2rem',
    }),
    alias: {
      extend: text,
      color: theme.colors.disabled,
    },
    rankExpiryDate: {
      extend: text,
      fontSize: '1.2rem',
      color: theme.colors.disabled,
    },
    points: {
      extend: text,
      marginTop: '0.75rem',
      '&::after': {
        content: '""',
        display: 'inline-block',
        backgroundImage: `url(${Arrow})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'contain',
        width: '0.7rem',
        height: '1.3rem',
        marginLeft: '0.5rem',
        transform: 'translateY(0.1rem)',
      },
    },
    pointsLink: {
      color: 'currentColor',
      textDecoration: 'none',
    },
    qrContainer: {
      flex: 0,
      display: 'flex',
      alignItems: 'center',
      '& span': {
        cursor: 'pointer',
      },
    },
    qrCodeButton: {
      appearance: 'none',
      border: 'none',
      outline: 'none',
      background: 'none',
      padding: 0,
      margin: 0,
      cursor: 'pointer',
      '&:disabled': {
        cursor: 'default',
      },
      backgroundColor: 'var(--ui-profile-card-qrcode-background-color)',
      color: 'var(--ui-profile-card-qrcode-color)',
      width: '7.2rem',
      aspectRatio: '1 / 1',
      borderRadius: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    qrCodeButtonIcon: {

    },
  }
})

export default useStyles
